/*=========================================================================================
  File Name: modulePurchaseReturnState.js
  Description: Purchase Return Module State
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {};
